export const background =
  '-webkit-linear-gradient(-45deg,rgba(253,113,113,0) 33%,rgba(255,222,222,.1) 0,rgba(251,229,229,.1) 66%,rgba(247,148,148,0) 0),-webkit-linear-gradient(top,rgba(255,211,211,.25),#d7dffb),-webkit-linear-gradient(left,#d4ddff,#fefeff)'
